import React, { useEffect, useState, useRef } from 'react';
import { connect, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import qs from 'qs';
import * as Yup from 'yup';
import { Form, Button, Row, Col, Pagination, Card } from 'react-bootstrap';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import {
  FaSearch,
  FaPlus,
  FaMinus,
  FaFilePdf,
  FaFileUpload,
  FaFileContract,
  FaFileExcel,
  FaStar,
  FaStarHalfAlt,
  FaEdit,
  FaHome,
  FaArchive,
} from 'react-icons/fa';
import { Formik, Field } from 'formik';
import Header from '~/Components/Header/Header';
import * as api from '~/Services/Service';
import { default as Selector } from 'react-select';
import DateMask from '~/Components/DateMask';
import * as constants from '~/constant';
import MaskedInput from 'react-text-mask';
import Loading from '~/Components/Loading';
import { toast } from 'react-toastify';
import AuthStorage from '~/Utils/AuthStorage';
import ModalDocumentos from '~/Components/AdmVendas/ModalDocumentos';
import ModalPendente from '~/Components/AdmVendas/ModalPendente';
import ModalAnexarComprovante from '~/Components/AdmVendas/ModalAnexarComprovante';
import ModalDetalhes from '~/Components/AdmVendas/ModalDetalhes';
import ModalCEDOC from '~/Components/AdmVendas/ModalCEDOC';
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'moment';
import { createDate, salvarEmExcel } from '~/Utils/Helpers';
import { openPopup } from '~/Utils/Helpers';
import { URLV1 } from '~/Components/Navbar/links';
import { Tooltip } from '@material-ui/core';

const mapStateToProps = state => ({
  userLogged: state.auth.user,
});

const AdmVendas = () => {
  const [btnMaisFiltros, setBtnMaisFiltros] = useState(false);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [propostas, setPropostas] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mostrarModalConferido, setMostrarModalConferido] = useState(false);
  const [mostrarModalComprovante, setMostrarModalComprovante] = useState(false);
  const [mostrarModalDetalhes, setMostrarModalDetalhes] = useState(false);
  const [mostrarModalCEDOC, setMostrarModalCEDOC] = useState(false);
  const [contratoCEDOCSelecionado, setContratoCEDOCSelecionado] = useState(
    null
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(20);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

  const optionsDigitalizacao = [
    { value: '-1', label: 'Boleto' },
    { value: '0', label: 'Aguardando Recebimento' },
    { value: '1', label: 'Aguardando Comprovante' },
    { value: '2', label: 'Comprovante Inserido' },
    { value: '3', label: 'Aprovado Sec. Vendas' },
    { value: '5', label: 'Aprovado Sec. Vendas (Cheque)' },
    { value: '-2', label: 'Aprovado Sec. Vendas (Cartão)' },
    { value: '-3', label: 'Aprovado Sec. Vendas (Depósito)' },
    { value: '4', label: 'Aprovado Dpto. Financeiro' },
    { value: '8', label: 'Recusado Dpto. Financeiro' },
    { value: '9', label: 'Recusado Sec. Vendas' },
    { value: '10', label: 'Pendente Dpto. Financeiro' },
  ];
  const optionsContratoDigital = [
    { value: '0', label: 'Contrato Físico' },
    { value: '1', label: 'Assinatura Digital Solicitada' },
    { value: '2', label: 'Assinatura Digital Aprovada' },
    { value: '3', label: 'Assinatura Digital Reprovada' },
    { value: '6', label: 'Pendente Assinaturas Setpar' },
    { value: '5', label: 'Pendente Assinaturas Clientes' },
    { value: 'G:2', label: 'Pendente Assinaturas Testemunhas' },
    { value: 'G:3', label: 'Pendente Assinaturas Procuradores' },
    { value: 'G:4', label: 'Pendente Assinaturas Validadores' },
    { value: '8', label: 'Finalizado' },
    { value: '10', label: 'Implantado/Finalizado' },
  ];
  const optionsFase = [
    { value: '1', label: '2 - Financeiro - Valor Não Entregue' },
    { value: '2', label: '3 - Secretaria de Vendas - Lançamento' },
    { value: '3', label: '4 - Corretor - Venda pendente para regularização' },
    { value: '4', label: '5 - Secretaria de Vendas - Emissão Contrato' },
    { value: '5', label: '6 - Cliente - Aguardando Assinatura' },
    { value: '6', label: '7 - Diretoria - Aguardando Assinatura' },
    { value: '7', label: '8 - Financeiro - Aguardando Quitar Sinal' },
    { value: '8', label: '9 - Cliente - Contrato Enviado' },
  ];

  const optionsConferencia = [
    { value: '1', label: 'Não conferido' },
    { value: '2', label: 'Pendente' },
    { value: '3', label: 'Conferido' },
    { value: '4', label: 'Ajustado' },
  ];

  const validationSchema = Yup.object().shape({
    data_inicial: Yup.string()
      .matches(/^\d{2}\/\d{2}\/\d{4}$/, 'Formato de data inválido')
      .test('valid-date', 'Data inválida', value => {
        if (!value) return true;
        return moment(value, 'DD/MM/YYYY', true).isValid();
      })
      .test('data-inicial-require-pair', 'Preencha a data final', function(
        value
      ) {
        const { data_final } = this.parent;
        if (value && !data_final) {
          return false;
        }
        return true;
      }),
    data_final: Yup.string()
      .matches(/^\d{2}\/\d{2}\/\d{4}$/, 'Formato de data inválido')
      .test('valid-date', 'Data inválida', value => {
        if (!value) return true;
        return moment(value, 'DD/MM/YYYY', true).isValid();
      })
      .test('data-final-require-pair', 'Preencha a data inicial', function(
        value
      ) {
        const { data_inicial } = this.parent;
        if (value && !data_inicial) {
          return false;
        }
        return true;
      }),
  });

  const totalPages = Math.ceil(propostas.length / recordsPerPage);
  const empreendimentos = useSelector(state => state.empreendimentos);
  const gerentesCorretores = useSelector(state => state.corretor);

  const sortedPropostas = React.useMemo(() => {
    if (sortConfig.key === 'ConferenciaOrdenacaoComposta') {
      return ordenacaoCompostaEtapaConferencia(sortConfig.direction);
    }
    if (sortConfig.key) {
      const sorted = [...propostas].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key])
          return sortConfig.direction === 'asc' ? -1 : 1;
        if (a[sortConfig.key] > b[sortConfig.key])
          return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
      });
      return sorted;
    }
    return propostas;
  }, [propostas, sortConfig]);

  function ordenacaoCompostaEtapaConferencia(direction = 'asc') {
    return [...propostas].sort((a, b) => {
      if (a.codigo_venda_conferencia < b.codigo_venda_conferencia)
        return direction === 'asc' ? -1 : 1;
      if (a.codigo_venda_conferencia > b.codigo_venda_conferencia)
        return direction === 'asc' ? 1 : -1;

      const dataA = new Date(a.data_etapa_conferencia);
      const dataB = new Date(b.data_etapa_conferencia);
      //a ordenação da data sempre será decrescente
      if (dataA < dataB) return 1;
      if (dataA > dataB) return -1;

      return 0;
    });
  }
  const currentRecords = React.useMemo(() => {
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    return sortedPropostas.slice(indexOfFirstRecord, indexOfLastRecord);
  }, [sortedPropostas, currentPage, recordsPerPage]);

  const handleSort = column => {
    let direction = 'asc';
    if (sortConfig.key === column && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key: column, direction });
  };

  const optionsEmpreendimentos = [
    ...empreendimentos.sort.map(item => ({
      value: item.codigo,
      label: item.codigo + ' - ' + item.descricao,
    })),
  ];

  const optionsGerentes = [
    ...gerentesCorretores.listaGerentes.map(ger => ({
      value: ger.codigo,
      label: ger.nome_imobiliaria,
    })),
  ];

  const optionsCorretores = [
    ...gerentesCorretores.listaCorretores.map(cor => ({
      value: cor.codigo,
      label: cor.codigo + ' - ' + cor.nome,
    })),
  ];

  const handlePageChange = pageNumber => {
    setCurrentPage(pageNumber);
  };

  const habilitarEDesabilitarMaisFiltros = () => {
    setBtnMaisFiltros(!btnMaisFiltros);
  };

  const abrirModalDocumentos = () => {
    setMostrarModal(!mostrarModal);
  };

  const abrirModalPendente = () => {
    setMostrarModalConferido(!mostrarModalConferido);
  };

  const abrirModalComprovante = () => {
    setMostrarModalComprovante(!mostrarModalComprovante);
  };

  const abrirModalDetalhes = () => {
    setMostrarModalDetalhes(!mostrarModalDetalhes);
  };

  const abrirModalCEDOC = item => {
    if (
      item &&
      item.fase === 9 &&
      item.pre_venda !== 0 &&
      item.assinatura === 'Físico'
    ) {
      setContratoCEDOCSelecionado({
        codigo: item.pre_venda,
        numeroPreVenda: item.pre_venda,
        nomeCliente: item.nome_cliente,
        nomeEmpreendimento: item.empreendimento,
        dataSolicitacao: item.data,
        statusArquivamento: 0,
      });
      setMostrarModalCEDOC(true);
    }
  };

  const permissoesCEDOC = {
    podeGerenciar: AuthStorage.temCaracteristica(
      constants.caracteristicas.AprovaCEDOC
    ),
  };

  const handleRowClick = item => {
    setSelectedRow(item);
  };

  const montarObjetoPagamento = propostaSelecionada => {
    switch (propostaSelecionada.pagto) {
      case 0:
        if (propostaSelecionada.tem_boleto_sinal === 'S') {
          return { cor: '#000', tooltip: 'Venda Sem Depósito / Cartão' };
        }
        return { cor: '#006400', tooltip: 'Aguardando recebimento' };
      case 1:
        return { cor: '#FFC516', tooltip: 'Aguardando Comprovante' };
      case 2:
        return { cor: '#3BAF56', tooltip: 'Comprovante Inserido' };
      case 3:
        return { cor: '#1E8BFF', tooltip: 'Aprovado Sec. Vendas' };
      case 4:
        return { cor: '#619DD8', tooltip: 'Aprovado Dpto. Financeiro' };
      case 5:
        return { cor: '#1E8BFF', tooltip: 'Aprovado Sec. Vendas (Cheque)' };
      case 8:
        return { cor: '#EA9384', tooltip: 'Recusado Dpto. Financeiro' };
      case 9:
        return { cor: '#DC3545', tooltip: 'Recusado Sec. Vendas' };
      case 10:
        return { cor: '#FFC107', tooltip: 'Assinatura Digital Pendente' };

      default:
        return { cor: '', tooltip: '' };
    }
  };

  const montarObjetoDocDigital = propostaSelecionada => {
    switch (propostaSelecionada.status_doc) {
      case 0:
      case 4:
      case 7:
        return { cor: '#000', tooltip: 'Solicitar Assinatura Digital' };
      case 1:
        return { cor: '#FE970A', tooltip: 'Assinatura Digital Solicitada' };
      case 2:
        return { cor: '#95B75D', tooltip: 'Assinatura Digital Aprovada' };
      case 3:
        return { cor: '#E04A4A', tooltip: 'Assinatura Digital Reprovada' };
      case 5:
        return { cor: '#007BFF', tooltip: 'Pendente Assinaturas Cliente' };
      case 6:
        if (propostaSelecionada.assinatura_pendente != '') {
          return {
            cor: '#0747A6',
            tooltip: propostaSelecionada.assinatura_pendente,
          };
        }
        return { cor: '#0747A6', tooltip: 'Pendente Assinaturas Setpar' };
      case 8:
        return { cor: '#729638', tooltip: 'Finalizado' };
      case 10:
        return { cor: '#729638', tooltip: 'Implantado/Finalizado' };
      default:
        return { cor: '#1E8BFF', tooltip: 'Acompanhar Assinatura Digital' };
    }
  };

  const montarObjetoCEDOC = propostaSelecionada => {
    const statusCEDOC = propostaSelecionada.status_cedoc;
    const statusInfo = constants.DESCRICOES_STATUS_CEDOC.find(
      s => s.value === statusCEDOC
    );
    if (statusInfo) {
      return { cor: statusInfo.cor, tooltip: statusInfo.label };
    }
    return { cor: '#6c757d', tooltip: 'Sem status CEDOC' };
  };

  const montarObjetoFase = propostaSelecionada => {
    switch (propostaSelecionada.fase) {
      case 1:
        return { cor: '#C0C0C0', tooltip: 'Corretor - Cadastro Rápido' };
      case 2:
        return { cor: '#00FFFF', tooltip: 'Financeiro - Valor Não Entregue' };
      case 3:
        return {
          cor: '#C0C0C0',
          tooltip: 'Secretaria de Vendas - Lançamento',
        };
      case 4:
        return {
          cor: '#FF00FF',
          tooltip: 'Corretor - Venda pendente para regularização',
        };
      case 5:
        return {
          cor: '#FFFF00',
          tooltip: 'Secretaria de Vendas - Emissão Contrato',
        };
      case 6:
        return { cor: '#00FF00', tooltip: 'Cliente - Aguardando Assinatura' };
      case 7:
        return {
          cor: '#FFA500',
          tooltip: 'Diretoria - Aguardando Assinatura',
        };
      case 8:
        return {
          cor: '#008000',
          tooltip: 'Financeiro - Aguardando Quitar Sinal',
        };
      case 9:
        return { cor: '#FF0000', tooltip: 'Cliente - Contrato Enviado' };
      default:
        return { cor: '', tooltip: '' };
    }
  };

  const consultarAdmVendas = async filtro => {
    try {
      setLoading(true);
      var filtroLimpo = Object.fromEntries(
        Object.entries(filtro).filter(
          ([_, value]) =>
            value !== '' &&
            value !== null &&
            value !== undefined &&
            value.length > 0
        )
      );

      if (filtroLimpo.data_inicial) {
        filtroLimpo.data_inicial = createDate(
          filtroLimpo.data_inicial,
          'DD/MM/YYYY'
        ).format(constants.DATE_FORMAT_SERVER);
        filtroLimpo.data_final = createDate(
          filtroLimpo.data_final,
          'DD/MM/YYYY'
        ).format(constants.DATE_FORMAT_SERVER);
      }

      const propostas = await api.consultarAdmVendas(filtroLimpo);
      setPropostas(propostas);
    } catch (error) {
      toast.error(error.message || 'Erro ao buscar propostas');
    } finally {
      setLoading(false);
      setCurrentPage(1);
    }
  };

  const montarLinkProspecto = propostaSelecionada => {
    try {
      let retorno = `/prospectos/${propostaSelecionada.codigo_prospecto}/dados-cliente/pessoais?Familia=${propostaSelecionada.familia}&PV=${propostaSelecionada.pre_venda}`;
      return retorno;
    } catch (error) {
      console.error('Erro ao construir o link do prospecto:', error);
    }
  };

  const montarLinkDocDigital = async pre_venda => {
    let codigoDoc = await api.obterCodigoDocDigital(pre_venda);
    if (codigoDoc === 0) {
      return '/documentodigital?codPreVenda=' + pre_venda;
    } else {
      return '/documentodigital?codDocDigital=' + codigoDoc;
    }
  };

  const montarObjetoPesquisaPV = (codigo_boleto, codigo_resposta_pv) => {
    if (codigo_boleto > 0) {
      return {
        link: '/cliente/pesquisa/contratos/' + codigo_boleto,
        icone:
          codigo_resposta_pv > 0 ? (
            <FaStar color="#FFC516" size={18} title="Respondidas" />
          ) : (
            <FaStarHalfAlt color="#FFC516" size={18} title="Não Respondidas" />
          ),
      };
    }
    return null;
  };

  const abrirProposta = linha => {
    let link =
      URLV1 +
      '/WebImob/Comercial/Prevenda.aspx?proposta=' +
      linha.codigo_proposta +
      '&seq=' +
      linha.seq;
    window.open(link, '_blank');
  };

  const montarObjetoDocumentoDigital = linha => {
    if (linha.pre_venda == 0) {
      return {
        funcao: 'Abrir Proposta',
        icone: <FaEdit color="black" size={18} title="Ver Proposta" />,
      };
    }
    return {
      funcao: 'Abrir Documentos',
      icone: <FaFilePdf color="#e12929" size={18} title="Ver Documentos" />,
    };
  };

  const [modoMobile, setModoMobile] = useState(window.innerWidth <= 768);
  const location = useLocation();
  const formikRef = useRef(null);

  useEffect(() => {
    if (window.innerWidth <= 770) {
      setModoMobile(true);
      return;
    }
    setModoMobile(false);
  }, [window.innerWidth]);

  useEffect(() => {
    const params = qs.parse(location.search, { ignoreQueryPrefix: true });
    if (params.codigo_proposta) {
      var filtro = { codigo_proposta: params.codigo_proposta };
      if (params.codigo_prospecto) {
        filtro.codigo_prospecto = params.codigo_prospecto;
      }
      consultarAdmVendas(filtro);
      if (formikRef.current) {
        formikRef.current.setFieldValue('codigo_proposta', params.codigo_proposta);
        if (params.codigo_prospecto) {
          formikRef.current.setFieldValue('codigo_prospecto', params.codigo_prospecto);
        }
      }
    }
  }, [location.search]);

  return (
    <div>
      <Header title="Administração de Vendas" />
      <Formik
        innerRef={formikRef}
        initialValues={{
          codigos_gerente: '',
          codigos_corretor: '',
          codigo_prospecto: '',
          pre_venda: '',
          codigos_status_digitalizacao: '',
          codigos_empreendimento: '',
          quadra: '',
          lote: '',
          codigos_venda_conferencia: '',
          tipo_assinatura: '',
          codigos_status_documento_digital: '',
          data_inicial: '',
          data_final: '',
          fases: '',
          efetivadas: '',
          status: 'P',
          pesquisa_prevenda_respondidas: '',
          codigo_proposta: '',
          tem_solicitacao_cancelamento: '',
          status_cedoc: '',
        }}
        validationSchema={validationSchema}
        onSubmit={filtro => {
          consultarAdmVendas(filtro);
        }}
      >
        {({ handleSubmit, setFieldValue, errors, touched, values }) => (
          <Form
            onSubmit={handleSubmit}
            className="container-fluid bg-white p-3"
          >
            <Row>
              <Col xs={12} sm={6} md={4} lg={2}>
                <Form.Group controlId="codigos_gerente">
                  <small>Imobiliária</small>
                  <Selector
                    isMulti={true}
                    options={optionsGerentes}
                    placeholder={'Todas...'}
                    onChange={selectedOptions => {
                      setFieldValue(
                        'codigos_gerente',
                        selectedOptions
                          ? selectedOptions
                              .map(option => option.value)
                              .join(',')
                          : ''
                      );
                    }}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} sm={6} md={4} lg={3}>
                <Form.Group controlId="codigos_corretor">
                  <small>Corretor</small>
                  <Selector
                    isMulti={true}
                    placeholder="Todos..."
                    options={optionsCorretores}
                    onChange={selectedOptions => {
                      setFieldValue(
                        'codigos_corretor',
                        selectedOptions
                          ? selectedOptions
                              .map(option => option.value)
                              .join(',')
                          : []
                      );
                    }}
                  />
                </Form.Group>
              </Col>

              <Col xs={12} sm={6} md={3} lg={2}>
                <Form.Group controlId="codigo_prospecto">
                  <small>Prospecto</small>
                  <Field
                    type="text"
                    name="codigo_prospecto"
                    className="form-control"
                  />
                </Form.Group>
              </Col>
              <Col xs={12} sm={6} md={3} lg={2}>
                <Form.Group controlId="pre_venda">
                  <small>Pré-venda</small>
                  <Field
                    type="text"
                    name="pre_venda"
                    className="form-control"
                  />
                </Form.Group>
              </Col>
              <Col xs={12} sm={6} md={4} lg={3}>
                <Form.Group controlId="codigos_status_digitalizacao">
                  <small>Digitalização</small>
                  <Selector
                    isMulti={true}
                    placeholder="Todos..."
                    options={optionsDigitalizacao}
                    onChange={selectedOptions => {
                      setFieldValue(
                        'codigos_status_digitalizacao',
                        selectedOptions
                          ? selectedOptions
                              .map(option => option.value)
                              .join(',')
                          : []
                      );
                    }}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} sm={6} md={5} lg={3}>
                <Form.Group controlId="codigos_empreendimento">
                  <small>Empreendimento</small>
                  <Selector
                    isMulti={true}
                    noOptionsMessage={() => 'Nenhum empreendimento encontrado'}
                    placeholder="Todos..."
                    options={optionsEmpreendimentos}
                    onChange={selectedOptions => {
                      setFieldValue(
                        'codigos_empreendimento',
                        selectedOptions
                          ? selectedOptions
                              .map(option => option.value)
                              .join(',')
                          : []
                      );
                    }}
                  />
                </Form.Group>
              </Col>
              <Col xs={6} sm={6} md={2} lg={1}>
                <Form.Group controlId="quadra">
                  <small>Quadra</small>
                  <Field type="text" name="quadra" className="form-control" />
                </Form.Group>
              </Col>
              <Col xs={6} sm={6} md={2} lg={1}>
                <Form.Group controlId="lote">
                  <small>Lote</small>
                  <Field type="text" name="lote" className="form-control" />
                </Form.Group>
              </Col>
              <Col xs={12} sm={6} md={3} lg={2}>
                <Form.Group controlId="codigos_venda_conferencia">
                  <small>Conferência</small>
                  <Selector
                    isMulti={true}
                    options={optionsConferencia}
                    placeholder={'Todas...'}
                    onChange={selectedOptions => {
                      setFieldValue(
                        'codigos_venda_conferencia',
                        selectedOptions
                          ? selectedOptions
                              .map(option => option.value)
                              .join(',')
                          : []
                      );
                    }}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} sm={6} md={3} lg={2}>
                <Form.Group controlId="status">
                  <small>Status</small>
                  <Field as="select" name="status" className="form-control">
                    <option value="P">Pendentes</option>
                    <option value="T">Todos</option>
                  </Field>
                </Form.Group>
              </Col>
              <Col xs={12} sm={6} md={4} lg={3}>
                <Form.Group controlId="codigos_status_documento_digital">
                  <small>Contrato digital</small>
                  <Selector
                    isMulti={true}
                    placeholder="Todos..."
                    options={optionsContratoDigital}
                    onChange={selectedOptions => {
                      setFieldValue(
                        'codigos_status_documento_digital',
                        selectedOptions
                          ? selectedOptions
                              .map(option => option.value)
                              .join(',')
                          : []
                      );
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>

            {btnMaisFiltros && (
              <Row>
                <Col xs={12} sm={6} md={3} lg={2}>
                  <DateMask
                    allowEmpty
                    onValidate={value => setFieldValue('data_inicial', value)}
                  >
                    {({ dateError, dateValue, setDate }) => (
                      <Form.Group controlId="data_inicial">
                        <small>Data inicial</small>
                        <MaskedInput
                          name="data_inicial"
                          type="tel"
                          guide={false}
                          className={`form-control`}
                          placeholder="Ex.: 01/01/2019"
                          mask={constants.MASK_DATE}
                          value={values.data_inicial}
                          onChange={e => {
                            setFieldValue('data_inicial', e.target.value);
                          }}
                        />
                        <Form.Control.Feedback
                          className="d-flex"
                          type="invalid"
                        >
                          {errors && errors.data_inicial}
                        </Form.Control.Feedback>
                      </Form.Group>
                    )}
                  </DateMask>
                </Col>
                <Col xs={12} sm={6} md={3} lg={2}>
                  <DateMask
                    allowEmpty
                    onValidate={value => setFieldValue('data_final', value)}
                  >
                    {({ dateError, dateValue, setDate }) => (
                      <Form.Group controlId="data_final">
                        <small>Data final</small>
                        <MaskedInput
                          name="data_final"
                          type="tel"
                          guide={false}
                          className={`form-control ${
                            errors.data_final && touched.data_final
                              ? 'is-invalid'
                              : ''
                          }`}
                          placeholder="Ex.: 01/01/2019"
                          mask={constants.MASK_DATE}
                          value={values.data_final}
                          onChange={e => {
                            setFieldValue('data_final', e.target.value);
                          }}
                        />

                        <Form.Control.Feedback
                          className="d-flex"
                          type="invalid"
                        >
                          {errors.data_final}
                        </Form.Control.Feedback>
                      </Form.Group>
                    )}
                  </DateMask>
                </Col>
                <Col xs={12} sm={6} md={4} lg={4}>
                  <Form.Group controlId="fases">
                    <small>Fase</small>
                    <Selector
                      isMulti={true}
                      placeholder="Todas..."
                      options={optionsFase}
                      onChange={selectedOptions => {
                        setFieldValue(
                          'fases',
                          selectedOptions
                            ? selectedOptions
                                .map(option => option.value)
                                .join(',')
                            : []
                        );
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} sm={6} md={3} lg={2}>
                  <Form.Group controlId="pesquisa_prevenda_respondidas">
                    <small>Pesquisa</small>
                    <Field
                      as="select"
                      name="pesquisa_prevenda_respondidas"
                      className="form-control"
                    >
                      <option value="">Selecione...</option>
                      <option value="1">Respondidas</option>
                      <option value="0">Não respondidas</option>
                    </Field>
                  </Form.Group>
                </Col>
                <Col xs={12} sm={6} md={3} lg={2}>
                  <Form.Group controlId="tipo_assinatura">
                    <small>Tipo assinatura</small>
                    <Field
                      as="select"
                      name="tipo_assinatura"
                      className="form-control"
                    >
                      <option value="">Selecione...</option>
                      <option value="F">Físico</option>
                      <option value="D">Digital</option>
                    </Field>
                  </Form.Group>
                </Col>
                <Col xs={12} sm={6} md={3} lg={2}>
                  <Form.Group controlId="efetivadas">
                    <small>Vendas efetivadas</small>
                    <Field
                      as="select"
                      name="efetivadas"
                      className="form-control"
                    >
                      <option value="">Selecione...</option>
                      <option value="false">Não</option>
                      <option value="true">Sim</option>
                    </Field>
                  </Form.Group>
                </Col>
                <Col xs={12} sm={6} md={3} lg={2}>
                  <Form.Group controlId="codigo_proposta">
                    <small>Proposta</small>
                    <Field
                      type="text"
                      name="codigo_proposta"
                      className="form-control"
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} sm={6} md={4} lg={4}>
                  <Form.Group controlId="tem_solicitacao_cancelamento">
                    <small>Aguardando cancelamento doc Digital</small>
                    <Field
                      as="select"
                      name="tem_solicitacao_cancelamento"
                      className="form-control"
                    >
                      <option value="">Selecione...</option>
                      <option value="false">Não</option>
                      <option value="true">Sim</option>
                    </Field>
                  </Form.Group>
                </Col>
                <Col xs={12} sm={6} md={3} lg={2}>
                  <Form.Group controlId="status_cedoc">
                    <small>Status CEDOC</small>
                    <Selector
                      isMulti={true}
                      placeholder="Todos..."
                      options={constants.DESCRICOES_STATUS_CEDOC.map(s => ({
                        value: s.value.toString(),
                        label: s.label,
                      }))}
                      onChange={selectedOptions => {
                        setFieldValue(
                          'status_cedoc',
                          selectedOptions
                            ? selectedOptions
                                .map(option => option.value)
                                .join(',')
                            : ''
                        );
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
            )}
            <div className="d-flex justify-content-end align-itens-center">
              <Button
                variant="outline-primary"
                type="button"
                onClick={habilitarEDesabilitarMaisFiltros}
                className="col-xs-12 col-sm-6 col-md-4 col-lg-1 mr-3"
              >
                {btnMaisFiltros ? <FaMinus /> : <FaPlus />}
                <span className="d-xs-none">
                  {btnMaisFiltros ? ' Filtros' : ' Filtros'}
                </span>
              </Button>
              <Button
                disabled={Object.values(errors).length > 0 || loading}
                variant="success"
                type="submit"
                className="col-xs-12 col-sm-6 col-md-4 col-lg-1"
              >
                <FaSearch />
                <span className="d-xs-none"> Buscar</span>
              </Button>
            </div>
          </Form>
        )}
      </Formik>

      {loading && <Loading />}
      {!loading && currentRecords.length > 0 && (
        <div className="container-fluid bg-white table-responsive">
          {!modoMobile && (
            <Table className="table table-striped table-bordered table-hover">
              <Thead>
                <Tr className="text-center font-size-14">
                  <Th
                    onClick={() => handleSort('data')}
                    style={{ cursor: 'pointer' }}
                  >
                    Data
                  </Th>
                  <Th
                    onClick={() => handleSort('fase')}
                    style={{ cursor: 'pointer' }}
                  >
                    Fase
                  </Th>
                  <Th
                    onClick={() => handleSort('pre_venda')}
                    style={{ cursor: 'pointer' }}
                  >
                    Pré-Venda
                  </Th>
                  <Th
                    onClick={() => handleSort('codigo_proposta')}
                    style={{ cursor: 'pointer' }}
                  >
                    Proposta
                  </Th>
                  <Th
                    onClick={() => handleSort('usuario')}
                    style={{ cursor: 'pointer' }}
                  >
                    Usuário
                  </Th>
                  <Th
                    onClick={() => handleSort('empreendimento')}
                    style={{ cursor: 'pointer' }}
                  >
                    Empreendimento
                  </Th>
                  <Th
                    onClick={() => handleSort('qd')}
                    style={{ cursor: 'pointer' }}
                  >
                    QD
                  </Th>
                  <Th
                    onClick={() => handleSort('lt')}
                    style={{ cursor: 'pointer' }}
                  >
                    LT
                  </Th>
                  <Th
                    onClick={() => handleSort('ge_cliente')}
                    style={{ cursor: 'pointer' }}
                  >
                    GE / Cliente - Nome
                  </Th>
                  <Th
                    onClick={() => handleSort('codigo_prospecto')}
                    style={{ cursor: 'pointer' }}
                  >
                    Prospecto
                  </Th>
                  <Th
                    onClick={() => handleSort('assinatura')}
                    style={{ cursor: 'pointer' }}
                  >
                    Assinatura
                  </Th>
                  <Th
                    onClick={() => handleSort('ConferenciaOrdenacaoComposta')}
                    style={{ cursor: 'pointer' }}
                  >
                    Conferido
                  </Th>
                  <Th>Pesquisa</Th>
                  <Th>Doc.</Th>
                  <Th
                    onClick={() => handleSort('pagto')}
                    style={{ cursor: 'pointer' }}
                  >
                    Comp.
                  </Th>
                  <Th
                    onClick={() => handleSort('status_doc')}
                    style={{ cursor: 'pointer' }}
                  >
                    ClickSign
                  </Th>
                  {AuthStorage.temCaracteristica(
                    constants.caracteristicas.AprovaCEDOC
                  ) && <Th>CEDOC</Th>}
                  <Th>+</Th>
                </Tr>
              </Thead>
              <Tbody className="text-center font-size-13">
                {currentRecords.length > 0 &&
                  currentRecords.map((item, index) => (
                    <Tr
                      key={index}
                      style={{
                        fontWeight: selectedRow === item ? 'bold' : 'normal',
                        cursor: 'pointer',
                        transition: 'background-color 0.1s ease',
                      }}
                      onClick={() => handleRowClick(item)}
                    >
                      <Td>
                        {new Intl.DateTimeFormat('pt-BR').format(
                          new Date(item.data)
                        )}
                      </Td>
                      <Td
                        className="text-center"
                        title={montarObjetoFase(item).tooltip}
                        style={{
                          fontWeight: 'bold',
                          color: montarObjetoFase(item).cor,
                        }}
                      >
                        {item.fase}
                      </Td>
                      <Td>
                        {item.pre_venda === 0
                          ? 'Sem Pré-venda'
                          : item.pre_venda}
                      </Td>
                      <Td>{item.codigo_proposta}</Td>
                      <Td>{item.usuario}</Td>
                      <Td className="text-left">{item.empreendimento}</Td>
                      <Td>{item.qd}</Td>
                      <Td>{item.lt}</Td>
                      <Td className="text-left">
                        <i>{item.ge_cliente + ' - ' + item.nome_cliente}</i>
                      </Td>
                      <Td style={{ textDecoration: 'underline' }}>
                        <i
                          onClick={() => {
                            const link = montarLinkProspecto(item);
                            if (link) {
                              openPopup(link, 'ClientePreVenda', 850, 700);
                            }
                          }}
                        >
                          {item.codigo_prospecto}
                        </i>
                      </Td>
                      <Td>{item.assinatura}</Td>
                      <Td
                        style={{ textDecoration: 'underline' }}
                        onClick={() => {
                          if (item.pre_venda !== 0) {
                            abrirModalPendente();
                          }
                        }}
                      >
                        {item.pre_venda !== 0
                          ? item.conferido
                          : 'Sem conferência'}
                        <br></br>
                        {item.pre_venda !== 0 && (
                          <small>
                            {item.data_etapa_conferencia
                              ? new Intl.DateTimeFormat('pt-BR').format(
                                  new Date(item.data_etapa_conferencia)
                                )
                              : ''}
                          </small>
                        )}
                      </Td>
                      <Td
                        onClick={() => {
                          if (item.boleto > 0) {
                            window.open(
                              montarObjetoPesquisaPV(
                                item.boleto,
                                item.codigo_resposta_pv
                              ).link,
                              '_blank'
                            );
                          }
                        }}
                      >
                        {item.boleto > 0 &&
                          montarObjetoPesquisaPV(
                            item.boleto,
                            item.codigo_resposta_pv
                          ).icone}
                      </Td>
                      <Td
                        className="text-center"
                        onClick={() => {
                          switch (montarObjetoDocumentoDigital(item).funcao) {
                            case 'Abrir Documentos':
                              abrirModalDocumentos();
                              break;
                            case 'Abrir Proposta':
                              abrirProposta(item);
                              break;
                          }
                        }}
                      >
                        {montarObjetoDocumentoDigital(item).icone}
                      </Td>
                      <Td
                        title={montarObjetoPagamento(item).tooltip}
                        className="text-center"
                        onClick={() => {
                          if (item.pre_venda !== 0) {
                            if (item.tem_boleto_sinal === 'N') {
                              abrirModalComprovante();
                            }
                          }
                        }}
                      >
                        {item.pre_venda !== 0 && (
                          <FaFileUpload
                            color={montarObjetoPagamento(item).cor}
                            size={18}
                          />
                        )}
                      </Td>
                      <Td
                        className="text-center"
                        title={
                          item.casa !== 0 &&
                          !AuthStorage.temCaracteristica(
                            constants.caracteristicas
                              .VisualizaContratoConstrucao
                          )
                            ? `Não é possível gerar contrato de compra e venda para ativo com construção (Ativo: ${item.casa})`
                            : montarObjetoDocDigital(item).tooltip
                        }
                        style={{
                          cursor:
                            item.casa !== 0 &&
                            !AuthStorage.temCaracteristica(
                              constants.caracteristicas
                                .VisualizaContratoConstrucao
                            )
                              ? 'not-allowed'
                              : 'pointer',
                        }}
                        onClick={async () => {
                          if (
                            item.pre_venda !== 0 &&
                            (item.casa === 0 ||
                              AuthStorage.temCaracteristica(
                                constants.caracteristicas
                                  .VisualizaContratoConstrucao
                              ))
                          ) {
                            let link = await montarLinkDocDigital(
                              item.pre_venda
                            );
                            if (link) {
                              window.open(link, '_blank');
                            }
                          }
                        }}
                      >
                        {item.pre_venda !== 0 &&
                          (item.casa !== 0 &&
                          !AuthStorage.temCaracteristica(
                            constants.caracteristicas
                              .VisualizaContratoConstrucao
                          ) ? (
                            <FaHome color="#6c757d" size={18} />
                          ) : (
                            <FaFileContract
                              color={montarObjetoDocDigital(item).cor}
                              size={18}
                            />
                          ))}
                      </Td>
                      {AuthStorage.temCaracteristica(
                        constants.caracteristicas.AprovaCEDOC
                      ) && (
                        <Td
                          title={
                            item.fase === 9 &&
                            item.pre_venda !== 0 &&
                            item.assinatura === 'Físico'
                              ? montarObjetoCEDOC(item).tooltip
                              : ''
                          }
                          style={{
                            cursor:
                              item.fase === 9 &&
                              item.pre_venda !== 0 &&
                              item.assinatura === 'Físico'
                                ? 'pointer'
                                : 'default',
                          }}
                          onClick={() => abrirModalCEDOC(item)}
                        >
                          {item.fase === 9 &&
                            item.pre_venda !== 0 &&
                            item.assinatura === 'Físico' && (
                              <FaArchive
                                color={montarObjetoCEDOC(item).cor}
                                size={18}
                              />
                            )}
                        </Td>
                      )}
                      <Td
                        title={
                          item.casa !== 0 ? `Ativo: ${item.casa} - Casa` : ''
                        }
                        onClick={() => {
                          if (item.pre_venda !== 0) {
                            abrirModalDetalhes();
                          }
                        }}
                      >
                        {item.pre_venda !== 0 && (
                          <FaSearch color="#0747a6" size={18} />
                        )}
                      </Td>
                    </Tr>
                  ))}
              </Tbody>
            </Table>
          )}
          {modoMobile &&
            currentRecords.length > 0 &&
            currentRecords.map((item, index) => (
              <Card
                className="px-2 mb-2 pb-2"
                key={index}
                style={{
                  fontWeight: selectedRow === item ? 'bold' : 'normal',
                  cursor: 'pointer',
                  backgroundColor: selectedRow === item ? '#f0f0f0' : 'white',
                }}
                onClick={() => handleRowClick(item)}
              >
                <ul className="list-unstyled d-flex flex-wrap ImobiliariaItemResumo produtividade justify-content-between text-md-left">
                  <li className="m-1">
                    <small>Data</small>
                    <strong className="d-block" style={{ fontSize: 'smaller' }}>
                      {new Intl.DateTimeFormat('pt-BR').format(
                        new Date(item.data)
                      )}
                    </strong>
                  </li>
                  <li className="m-1">
                    <small>Pré-Venda</small>
                    <strong className="d-block" style={{ fontSize: 'smaller' }}>
                      {item.pre_venda === 0 ? 'Sem pré-venda' : item.pre_venda}
                    </strong>
                  </li>
                  <li className="m-1">
                    <small>Usuário</small>
                    <strong className="d-block" style={{ fontSize: '13px' }}>
                      {item.usuario}
                    </strong>
                  </li>
                </ul>
                <ul className="list-unstyled d-flex flex-wrap ImobiliariaItemResumo produtividade justify-content-between text-md-left">
                  <li className="m-1">
                    <small>Empreendimento</small>
                    <strong className="d-block" style={{ fontSize: '11px' }}>
                      {item.empreendimento}
                    </strong>
                  </li>
                  <li className="m-1">
                    <small>QD / LT</small>
                    <strong className="d-block" style={{ fontSize: '13px' }}>
                      {item.qd} / {item.lt}
                    </strong>
                  </li>
                </ul>
                <ul className="list-unstyled d-flex flex-wrap ImobiliariaItemResumo produtividade justify-content-between text-md-left">
                  <li
                    onClick={() => {
                      if (item.pre_venda !== 0) {
                        abrirModalPendente();
                      }
                    }}
                    className="m-1"
                  >
                    <small>Conferência</small>
                    <strong
                      className="d-block"
                      style={{
                        textDecoration: 'underline',
                        fontSize: 'smaller',
                      }}
                    >
                      {item.pre_venda !== 0
                        ? item.conferido
                        : 'Sem conferência'}
                    </strong>
                  </li>

                  <li
                    className="m-1"
                    onClick={() => {
                      window.open(montarLinkProspecto(item), '_blank');
                    }}
                  >
                    <small>Prospecto</small>
                    <strong
                      className="d-block"
                      style={{
                        fontSize: 'smaller',
                        textDecoration: 'underline',
                      }}
                    >
                      {item.codigo_prospecto}
                    </strong>
                  </li>
                  <li className="m-1">
                    <small>Assinatura</small>
                    <strong className="d-block" style={{ fontSize: 'smaller' }}>
                      {item.assinatura}
                    </strong>
                  </li>
                </ul>
                <ul className="list-unstyled d-flex flex-wrap ImobiliariaItemResumo produtividade justify-content-between text-md-left">
                  {item.boleto > 0 && (
                    <li
                      className="m-1"
                      onClick={() => {
                        window.open(
                          montarObjetoPesquisaPV(
                            item.boleto,
                            item.codigo_resposta_pv
                          ).link,
                          '_blank'
                        );
                      }}
                    >
                      <strong>
                        {
                          montarObjetoPesquisaPV(
                            item.boleto,
                            item.codigo_resposta_pv
                          ).icone
                        }
                      </strong>
                    </li>
                  )}
                  <li
                    onClick={() => {
                      switch (montarObjetoDocumentoDigital(item).funcao) {
                        case 'Abrir Documentos':
                          abrirModalDocumentos();
                          break;
                        case 'Abrir Proposta':
                          abrirProposta(item);
                          break;
                      }
                    }}
                    className="m-1"
                  >
                    <strong>{montarObjetoDocumentoDigital(item).icone}</strong>
                  </li>
                  <li
                    className="m-1"
                    title={montarObjetoPagamento(item).tooltip}
                    onClick={() =>
                      item.tem_boleto_sinal === 'N'
                        ? abrirModalComprovante()
                        : () => {
                            return;
                          }
                    }
                  >
                    <strong>
                      {item.pre_venda !== 0 && (
                        <FaFileUpload
                          color={montarObjetoPagamento(item).cor}
                          size={18}
                        />
                      )}
                    </strong>
                  </li>
                  <li
                    className="m-1"
                    title={
                      item.casa !== 0 &&
                      !AuthStorage.temCaracteristica(
                        constants.caracteristicas.VisualizaContratoConstrucao
                      )
                        ? `Ativo: ${item.casa} - Casa`
                        : montarObjetoDocDigital(item).tooltip
                    }
                    style={{
                      cursor:
                        item.casa !== 0 &&
                        !AuthStorage.temCaracteristica(
                          constants.caracteristicas.VisualizaContratoConstrucao
                        )
                          ? 'not-allowed'
                          : 'pointer',
                    }}
                    onClick={async () => {
                      if (
                        item.casa === 0 ||
                        AuthStorage.temCaracteristica(
                          constants.caracteristicas.VisualizaContratoConstrucao
                        )
                      ) {
                        let link = await montarLinkDocDigital(item.pre_venda);
                        if (link) {
                          window.open(link, '_blank');
                        }
                      }
                    }}
                  >
                    <strong>
                      {item.pre_venda !== 0 &&
                        (item.casa !== 0 &&
                        !AuthStorage.temCaracteristica(
                          constants.caracteristicas.VisualizaContratoConstrucao
                        ) ? (
                          <FaHome color="#6c757d" size={18} />
                        ) : (
                          <FaFileContract
                            color={montarObjetoDocDigital(item).cor}
                            size={18}
                          />
                        ))}
                    </strong>
                  </li>
                  <li
                    className="m-1"
                    title={item.casa !== 0 ? `Ativo: ${item.casa} - Casa` : ''}
                    onClick={() => {
                      abrirModalDetalhes();
                    }}
                  >
                    <strong>
                      {item.pre_venda !== 0 && (
                        <FaSearch color="#0747a6" size={18} />
                      )}
                    </strong>
                  </li>
                </ul>
              </Card>
            ))}
          <div className="d-flex justify-content-between mb-2">
            <Pagination className="mb-0">
              <Pagination.First
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1}
              />
              <Pagination.Prev
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              />

              {totalPages > 10 && currentPage > 5 && (
                <Pagination.Ellipsis className="ellipsis" />
              )}

              {[...Array(totalPages).keys()]
                .slice(
                  Math.max(0, currentPage - 1),
                  Math.min(totalPages, currentPage + 1)
                )
                .map(number => (
                  <Pagination.Item
                    key={number}
                    active={currentPage === number + 1}
                    onClick={() => handlePageChange(number + 1)}
                  >
                    {number + 1}
                  </Pagination.Item>
                ))}
              {totalPages > 10 && currentPage < totalPages - 4 && (
                <Pagination.Ellipsis className="ellipsis" />
              )}
              <Pagination.Next
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              />
              <Pagination.Last
                onClick={() => handlePageChange(totalPages)}
                disabled={currentPage === totalPages}
              />
            </Pagination>

            <Button
              variant="success"
              type="submit"
              onClick={() => {
                salvarEmExcel(
                  propostas,
                  '/exportador/excel/relatorio-adm-vendas'
                );
              }}
            >
              <FaFileExcel />
              <span className="ml-2 ocultar-mobile">Salvar</span>
            </Button>
          </div>
        </div>
      )}
      {!loading && currentRecords.length === 0 && (
        <div className="text-center mt-4">
          <span>Nenhum resultado encontrado.</span>
        </div>
      )}
      {mostrarModal && (
        <ModalDocumentos
          mostrarModal={mostrarModal}
          setMostrarModal={setMostrarModal}
          preVenda={selectedRow.pre_venda}
          casa={selectedRow.casa}
        />
      )}
      {mostrarModalConferido && (
        <ModalPendente
          mostrarModal={mostrarModalConferido}
          setMostrarModal={setMostrarModalConferido}
          proposta={selectedRow}
          setProposta={setSelectedRow}
        />
      )}
      {mostrarModalComprovante && (
        <ModalAnexarComprovante
          mostrarModal={mostrarModalComprovante}
          setMostrarModal={setMostrarModalComprovante}
          linhaSelecionada={selectedRow}
        />
      )}
      {mostrarModalDetalhes && (
        <ModalDetalhes
          mostrarModal={mostrarModalDetalhes}
          setMostrarModal={setMostrarModalDetalhes}
          linhaSelecionada={selectedRow}
        />
      )}
      {mostrarModalCEDOC && contratoCEDOCSelecionado && (
        <ModalCEDOC
          mostrarModal={mostrarModalCEDOC}
          setMostrarModal={setMostrarModalCEDOC}
          contrato={contratoCEDOCSelecionado}
          permissoesCEDOC={permissoesCEDOC}
          onAtualizacao={() => {}}
        />
      )}
    </div>
  );
};

export default connect(mapStateToProps)(AdmVendas);
